import styled from "styled-components";

export const InfoP = styled.p`
  width: 100%;
  padding: 0 2rem;
  font-size: 1.4rem;
  color: var(--dark-grayish-blue);
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
`;
